import http from "../http"

class SalaryAnalysisService {

    _company() {
        return localStorage.getItem("companyId")
    }

    async getDashboard(filters = {}) {
        const data = { company_id: this._company(), ...filters }
        const rqst = await http.post("/cargos-salarios/dashboard/", data)
        return rqst.data
    }

    async listEmployeesWithoutSalary(page = 1, filters = {}) {
        const data = { company_id: this._company(), ...filters }
        const rqst = await http.post(
            `/cargos-salarios/employees-without-salary/list/?page=${page}`,
            data
        )
        return rqst.data
    }

    async listEmployeesWithSalary(page = 1, filters = {}) {
        const data = { company_id: this._company(), ...filters }
        const rqst = await http.post(
            `/cargos-salarios/employees-with-salary/list/?page=${page}`,
            data
        )
        return rqst.data
    }

    async listQuadro(page = 1, filters = {}) {
        const data = { company_id: this._company(), ...filters }
        const rqst = await http.post(`/cargos-salarios/quadro/?page=${page}`, data)
        return rqst.data
    }

    async listDepartamentos(filters = {}) {
        const data = { company_id: this._company(), ...filters }
        const rqst = await http.post("/cargos-salarios/departamentos/", data)
        return rqst.data
    }

    async listSubempresas() {
        const data = { company_id: this._company() }
        const rqst = await http.post("/cargos-salarios/subempresas/", data)
        return rqst.data
    }

    async getMapaCalor(filters = {}) {
        const data = { company_id: this._company(), ...filters }
        const rqst = await http.post("/cargos-salarios/mapa-calor/", data)
        return rqst.data
    }

    async compararEstruturas(structureIds) {
        const data = { company_id: this._company(), structure_ids: structureIds }
        const rqst = await http.post("/cargos-salarios/estruturas/comparar/", data)
        return rqst.data
    }

    async compararDepartamentos(departmentIds) {
        const data = { company_id: this._company(), department_ids: departmentIds }
        const rqst = await http.post("/cargos-salarios/departamentos/comparar/", data)
        return rqst.data
    }

    async compararSuborganizacoes(subcompanyIds) {
        const data = { company_id: this._company(), subcompany_ids: subcompanyIds }
        const rqst = await http.post("/cargos-salarios/subempresas/comparar/", data)
        return rqst.data
    }

    async createOrcamento(data) {
        const payload = { company_id: this._company(), ...data }
        const rqst = await http.post("/cargos-salarios/orcamento/create/", payload)
        return rqst.data
    }

    async listOrcamento(filters = {}) {
        const data = { company_id: this._company(), ...filters }
        const rqst = await http.post("/cargos-salarios/orcamento/list/", data)
        return rqst.data
    }

    async getOrcamentoScopeOptions(subcompanyId = null) {
        const data = { company_id: this._company() }
        if (subcompanyId) {
            data.subcompany_id = subcompanyId
        }
        const rqst = await http.post("/cargos-salarios/orcamento/scope-options/", data)
        return rqst.data
    }

    async deleteOrcamento(id) {
        const data = { company_id: this._company(), id }
        const rqst = await http.delete("/cargos-salarios/orcamento/delete/", { data })
        return rqst.data
    }

    async createEmployeeSalary(data) {
        const payload = { company_id: this._company(), ...data }
        const rqst = await http.post("/cargos-salarios/employee-salary/create/", payload)
        return rqst.data
    }

    async listEmployeeSalary(page = 1, filters = {}) {
        const data = { company_id: this._company(), ...filters }
        const rqst = await http.post(`/cargos-salarios/employee-salary/list/?page=${page}`, data)
        return rqst.data
    }

    async deleteEmployeeSalary(id) {
        const data = { company_id: this._company(), id }
        const rqst = await http.delete("/cargos-salarios/employee-salary/delete/", { data })
        return rqst.data
    }

    async getPolicyConfig() {
        const rqst = await http.get("/cargos-salarios/policy-config/", {
            params: { company_id: this._company() }
        })
        return rqst.data
    }

    async updatePolicyConfig(data) {
        const payload = { company_id: this._company(), ...data }
        const rqst = await http.post("/cargos-salarios/policy-config/", payload)
        return rqst.data
    }
}

const salaryAnalysisService = new SalaryAnalysisService()
export default salaryAnalysisService
